// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"700":"a3779dcd","739":"a8c8f5e2","888":"536fa792"}[chunkId] + ".chunk.css";
};